import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import CatalogListing from "@/pages/catalog/components/CatalogListing";
import InlineSearch from "@/pages/catalog/components/InlineSearch";
import usePageMeta from "@/hooks/usePageMeta";

export default function MoviesPage() {
  usePageMeta(
    "伦理电影 - 伦理视频",
    "伦理视频伦理电影频道，按地区、年代与评分筛选伦理题材电影，提供完整剧情介绍、角色分析与精选影评。",
    "伦理电影,伦理题材电影,电影推荐,电影剧情介绍,电影影评,伦理视频",
  );

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Ethics on Film"
        title="伦理电影"
        description="两小时之内的道德困境。这里收录了来自中国大陆、香港、台湾以及日韩、欧洲的伦理题材电影，每一部都附带剧情梳理、角色分析与独立影评，方便你按地区、年代和评分逐步筛选。"
        breadcrumbs={[{ label: "首页", to: "/" }, { label: "伦理电影" }]}
      >
        <InlineSearch tone="dark" />
      </PageHero>
      <CatalogListing kind="movie" />
    </SiteLayout>
  );
}